import { tabItems } from '@/modules/common/components/modals/ProfileSettingsModal/data.tsx';
import { ModalContentWrapper } from 'ui';

export interface ProfileSettingsModalProps {
  open: boolean;
  onClose: () => void;
}

const ProfileSettingsModal = ({ open, onClose }: ProfileSettingsModalProps) => {
  // const [activeTab, setActiveTab] = useState<TabNames>(TabNames.Settings);

  return (
    <ModalContentWrapper open={open} title="Settings" onClose={onClose}>
      <div className="w-full flex flex-colgap-4">
        {/*<div className="w-full flex items-center justify-start space-x-6 relative border-b border-gray-200 pb-[12px]">*/}
        {/*{tabItems.map(({ label, name }) => (*/}
        {/*  <button*/}
        {/*    key={name}*/}
        {/*    className={classNames('text-[14px] leading-[22px] font-medium relative', {*/}
        {/*      'text-gray-500': activeTab !== name,*/}
        {/*      'rounded-underline': activeTab === name,*/}
        {/*    })}*/}
        {/*    onClick={() => setActiveTab(name)}*/}
        {/*  >*/}
        {/*    {label}*/}
        {/*  </button>*/}
        {/*))}*/}
        {/*</div>*/}
        <div className="flex flex-col items-start w-full gap-4">
          {/*<Tabs items={tabItems} activeTab={activeTab} />*/}
          {tabItems[0].container}
        </div>
      </div>
    </ModalContentWrapper>
  );
};

export default ProfileSettingsModal;
